import { useContext } from 'react';

import PageLayoutContext from './PageLayoutContext';

export default function usePageLayout() {
  return useContext(PageLayoutContext);
}
